import {InputFileAcceptTypes} from "../../../../../core/constants/enums";
import React, {useState} from "react";
import {Row} from "reactstrap";
import Button from "../../../base/button/button";
import DropZone from "../../../base/dropzone";
import {ReactComponent as ImagePlaceholder} from "../../../../../assets/images/dropzone/upload-placeholder.svg";

const AddGiftCardsDropZone = ({
                                  error,
                                  disabled,
                                  accept = [InputFileAcceptTypes.csv],
                                  id = 'import-gift-cards',
                                  onSuccess,
                                  multiple = false,
                                  uploading,
                              }) => {
    const [loading, setLoading] = useState(false);


    return (
        <DropZone
            disabled={disabled}
            identifier={'documentation'}
            accept={accept}
            id={id}
            onSuccess={onSuccess}
            error={!!error}
            multiple={multiple}
            loading={loading}
            uploading={uploading}
            setLoading={setLoading}
            openOnClick
            className={`row no-gutters align-items-center justify-content-center `}
        >
            {(openFileDialog) =>
                <Row
                    className={`w-100 my-5 d-flex flex-column no-gutters align-items-center justify-content-center ${uploading ? 'cursor-progress-hover' : ''} ${disabled || loading ? 'cursor-not-allowed-hover' : 'cursor-pointer-hover'}`}>
                    <ImagePlaceholder className={'placeholder-image'}/>
                    <p className={`placeholder-text ${!!error ? 'red' : ''}`}>
                        Drag and Drop the file here
                        <br/>
                        File format: CSV
                    </p>
                    <Button
                        className='py-2 px-4'
                        color={'primary'}
                        variant={'text'}
                        onClick={openFileDialog}
                    >
                        {!!error ? "Retry" : "Choose File"}
                    </Button>
                </Row>
            }
        </DropZone>
    );
}

export default AddGiftCardsDropZone;
